import MuiButton from '@mui/material/Button';
import { clsx } from 'clsx';
import { FC } from 'react';
import { IButton } from './types';
import styles from './styles.module.css';

export const Button: FC<IButton> = ({
  theme = 'default',
  style,
  className,
  ...props
}) => {
  return (
    <MuiButton
      classes={{
        root: clsx(
          className,
          styles.root,
          styles[`${theme}-bg`],
          props.defaultWidth && styles.defaultWidth,
        ),
        containedSizeSmall: styles.sizeSmall,
        containedSizeMedium: styles.sizeMedium,
        disabled: styles.disabled,
      }}
      variant="contained"
      style={style}
      {...props}
    />
  );
};
